<template>
  <div>
    <div class="video-placeholder" @click="this.showModal">
      <img :src="this.thumbnailUrl" />
    </div>
    <Modal :show="isModalVisible" @hide="hideModal">
      <div class="video-container">
        <iframe
          :src="getVideoUrl()"
          ref="iframe"
          frameborder="0"
          webkitAllowFullScreen
          mozallowfullscreen
          allowFullScreen
        ></iframe>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../Modal/Modal.vue'
import Vimeo from '@vimeo/player'

export default {
  name: 'VideoPlayer',
  components: {
    Modal
  },
  props: {
    video: String
  },
  data() {
    return {
      thumbnailUrl: '',
      isModalVisible: false
    }
  },
  created() {
    this.getVideoData()
  },
  methods: {
    showModal: function () {
      this.isModalVisible = true
    },
    hideModal: function () {
      const videoPlayer = new Vimeo(this.$refs.iframe)
      videoPlayer.pause()
      this.isModalVisible = false
    },
    getVideoUrl() {
      return `//player.vimeo.com/video/${this.video}?color=25A037`
    },
    getVideoData: function () {
      fetch(
        `https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/${this.video}`,
        {
          method: 'GET'
        }
      )
        .then((response) => response.json())
        .then((data) => {
          this.thumbnailUrl = data.thumbnail_url
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
.video-placeholder {
  position: relative;
  cursor: pointer;

  &:before {
    width: 70px;
    height: 70px;
    content: '';
    background-image: url('~@/images/button-play.png');
    position: absolute;
    top: calc(50% - 35px);
    left: calc(50% - 35px);
  }

  img {
    min-width: 100%;
  }
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
